import { FC } from 'react';
import { useTheme } from 'styled-components';

import { ScInfoBtn, ScInfoBtnProps } from './styled';

interface InfoButtonProps extends ScInfoBtnProps {
  handleClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const InfoButton: FC<InfoButtonProps> = ({
  handleClick,
  gray,
  ...props
}) => {
  const { images } = useTheme();

  return (
    <ScInfoBtn onClick={handleClick} gray={gray} {...props}>
      <images.infoIcon.component />
    </ScInfoBtn>
  );
};
